<template>
  <div class="oneui">
    <div></div>
    <div>
      <ul class="nameWrapper" :style="`grid-template-columns: 1fr;`">
        <li></li>
        <li class="current">
          <span>{{$t('pages.settings.accessibility')}}</span>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="pageWrapper">
      <div class="page">
        <div class="ul">
          <div class="li">
            <span>
              <center>{{$t('pages.settings.highContrast')}}</center>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsButton from "@/components/SettingButton";
export default {
  name: "SettingsAccessibility",
  components: {
    SettingsButton
  }
};
</script>